// dbext:profile=staging_mcdo2019_be
import $ from "jquery";

import admin_general                  from "./905-admin_general.js";
import admin_crud                     from "./910-admin_crud.js";
import admin_restaurant_opening_hours from "./932-admin_restaurant_opening_hours.js";
import admin_tinymce                  from "./914-admin_tinymce.js";

/*

select * from 260_service_restaurant where restaurant_id not in ( select id from 200_restaurant )
select * from 210_opening_hours      where restaurant_id not in ( select id from 200_restaurant )
delete from 210_opening_hours      where restaurant_id not in ( select id from 200_restaurant )

*/

export default {

    init()
    {
        // restaurants overview?
        if ( $('.c-admin-restaurants' ).length > 0 ){
            this.init_restaurants();
        }
        // restaurants page?
        else if ( $('.c-admin-restaurant' ).length > 0 ){
            this.init_restaurant();
        }
    },

    // ⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩  RESTAURANTS  ⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩

    async init_restaurants()
    {
        // add McDonald's breadcrumb
        admin_general.bread_crumb_add_mcdonalds_link();
    },

    //⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩  RESTAURANT  ⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩

    async init_restaurant()
    {
        // add McDonald's breadcrumb
        admin_general.bread_crumb_add_mcdonalds_link();

        // event handlers
        $('.js-form'                     ).on( 'submit', this.on__form__submit()             );
        $('.js-delete-button'            ).on( 'click' , this.on__delete_button__click()     );
        $('.js-tab__delete'              ).on( 'click' , this.on__delete_tab__click()        );
        $('.js-restaurant__lat-long-link').on( 'click' , this.on__generate_lat_long__click() );
        $('.js-restaurant__link-view-lat-long-on-map').on( 'click', this.on__link_goto_map__click() );

        // generate slug buttons
        if ( $('.js-link-generate-slug--restaurant').length > 0 ){
            $('.js-link-generate-slug--restaurant').on( 'click', this.on__slug_arrow__click() );
        }
        $('[name="name"]').on( 'blur', this.on__name__blur() );

        // reset all checkboxes (they get checked later)
        $('input[type="checkbox"]').prop( 'checked', false );

        // init opening hours
        admin_restaurant_opening_hours.init_opening_hours();

        // insert mode?
        if ( g_mode === 'insert' ){

            // some services are default on ⇒ check these
            for ( let de_service  of  $('input[name="service_id"]').toArray() ){
                de_service = $(de_service);
                let checked = ( de_service.data('default_on_off') === 'on' ) ? true : false;
                de_service.prop( 'checked', checked  );
            }
        }

        // update mode? ⇒ make frontend reflect g_restaurant
        if ( g_mode === 'update' ){


            for ( let [ key, value ] of Object.entries( g_restaurant ) ){

                // empty value? ⇒ do nothing
                if ( value === null ){
                    continue;
                }

                // we need strings from now on
                if ( typeof value !== 'string' ){

                    // LAT LNG exceptions => return as numbers from the database
                    if (key === 'lat_times_a_million') {
                        $('[name=lat_times_a_million]').val( value );
                    } else if (key === 'lng_times_a_million') {
                        $('[name=lng_times_a_million]').val( value );
                    }

                    continue;
                }

                // get the DOM element
                let de = $('[name="' + key + '"]');
                if ( de.length === 0 ){
                    continue;
                }

                // The delivery partners contain a hidden input with the same name
                // to force submitting 0 when the checkbox is not set.
                // Avoid that we select here the hidden input instead of the checkbox
                if ( key.indexOf('delivery_partner') !== -1 ){
                    de = $('[name="' + key + '"][type="checkbox"]');
                }

                // input type checkbox
                if ( de.attr('type') === 'checkbox' ){

                    de.prop( 'checked', ( value == 1 ) );
                    continue;
                }

                // input type text
                if ( de.attr('type') === 'text' ){
                    de.val( value );
                    continue;
                }

                // textarea
                if ( de.is( 'textarea' ) ){
                    de.val( value );
                    continue;
                }

            }

            for ( let service of g_restaurant.services ){
                $('input[name="service_id"][value="'+service.service_id+'"]').prop( 'checked', true  );
            }
        }

        admin_tinymce.init();
    },

    on__form__submit()
    {
        return async ( e ) => {

            e.preventDefault();

            admin_general.start_spinning();

            // delete button clicked? ⇒ handle separately
            if ( $('.js-delete-button').data( 'delete-button-clicked' ) ){
                $('.js-delete-button').removeData( 'delete-button-clicked' );
                return this.on__form_delete__submit();
            }

            { // collect form data
                var restaurant_data = {};
                var service_ids = [];

                // get form data
                let form_data = $('.js-form').serializeArray();

                // form data → data structures
                for ( let { name, value } of form_data ){

                    // handle opening hours separately
                    if ( name.match( /^opho_/ ) ){
                        continue;
                    }

                    if ( name == 'service_id' ){
                        service_ids.push( value );
                        continue;
                    }

                    // TinyMCE? ⇒ retreive value with tinymce.get()
                    if (   name == 'opening_hours_en'
                        || name == 'opening_hours_nl'
                        || name == 'opening_hours_fr'
                        || name == 'opening_hours_mcdelivery_en'
                        || name == 'opening_hours_mcdelivery_nl'
                        || name == 'opening_hours_mcdelivery_fr'
                       ){
                           var id_opening_hours = 'i-' + name ;
                           restaurant_data[ name ] = admin_tinymce.get_content( id_opening_hours );
                           continue;
                   }

                    restaurant_data[ name ] = value;
                }
            }

            // validate_input
            let validated = this.validate_input( restaurant_data );
            let opho_validated = admin_restaurant_opening_hours.validate_input();
            if ( ! validated || ! opho_validated ){

                // show errors
                $('.c-saved.c-saved--errors').show();
                $('.c-saved.c-saved--errors').fadeOut( 2000 );

                admin_general.stop_spinning();

                return;
            }

            // this will contain the restaurant-id later
            let restaurant_id = false;

            // insert? ⇒ insert restaurant data in database and get the restaurant_id
            if ( g_mode === 'insert' ){

                // insert restaurant data cfr. 910-admin-crud.js
                let response = await
                admin_crud.POST( admin_crud.posturl( '200_restaurant', 'insert' ), {
                    data : restaurant_data,
                } );

                restaurant_id = response.data.id;
            }

            // update? ⇒ update restaurant data in database
            if ( g_mode === 'update' ){

                // get restaurant-id from g_restaurant
                restaurant_id = g_restaurant.id

                let ids = {
                    'id': restaurant_id,
                };

                let response = await
                admin_crud.POST( admin_crud.posturl( '200_restaurant', 'update' ), {
                    ids  : {
                            'id': restaurant_id,
                           },
                    data : restaurant_data,
                } );

            }

            { // handle services
                if ( g_mode === 'insert' ){
                    await this.insert_services( restaurant_id, service_ids );
                }
                if ( g_mode === 'update' ){
                    await this.delete_service_restaurant_records_of_restaurant( restaurant_id );
                    await this.insert_services( restaurant_id, service_ids );
                }
            }

            { // handle opening hours
                await admin_restaurant_opening_hours.on__form__submit( g_mode, restaurant_id );
            }

            { // handle redirect/reload

                if ( g_mode === 'insert' ){

                    let target_url = '/admin/restaurant/' + restaurant_id;

                    // redirect to the edit page of the new restaurant
                    window.location.replace( target_url );
                }
                else if ( g_mode === 'update' ){

                    // show restaurant saved
                    $('.c-saved.c-saved--ok').show();
                    $('.c-saved.c-saved--ok').fadeOut('slow');
                }
            }

            admin_general.stop_spinning();
        };
    },

    on__delete_button__click()
    {
        return ( e ) => {
            $('.js-delete-button').data( 'delete-button-clicked', true );
        };
    },

    on__delete_tab__click()
    {
        return ( e ) => {
            e.preventDefault();

            // fake that somebody clicked on the delete button on the bottom of the page
            $('.js-delete-button').click();
        };
    },

    async on__form_delete__submit()
    {
        // are your sure?
        if ( ! confirm( 'Are you sure?' ) ){
            admin_general.stop_spinning();
            return; // user is not sure...
        }

        let restaurant_id = g_restaurant.id;

        // delete corresponding dependent restaurant service records
        await this.delete_service_restaurant_records_of_restaurant( restaurant_id );

        // delete corresponding dependent opening hours
        await admin_restaurant_opening_hours.delete_opening_hours_of_restaurant( restaurant_id );

        // delete restaurant record
        let response = await
        admin_crud.POST( admin_crud.posturl( '200_restaurant', 'delete' ), {
            ids : {
                id : restaurant_id,
            },
        } );

        // redirect to restaurants overview
        window.location.replace( '/admin/restaurants' );

        return;
    },

    on__generate_lat_long__click()
    {
        return async ( e ) => {
            e.preventDefault();

            // street: get first language that is set NL/FR/EN
            let street = '';
            for ( let field_name of [ 'street_nl', 'street_fr', 'street_en' ] ){
                let de = $('input[name="'+field_name+'"]');
                if ( de.val() ){
                    street = de.val();
                    break;
                }
            }

            // nr
            let nr = '';
            {
                let de = $('input[name="nr"]');
                if ( de.val() ){
                    nr = de.val();
                }
            }

            // postal-code
            let postal_code = '';
            {
                let de = $('input[name="postal_code"]');
                if ( de.val() ){
                    postal_code = de.val();
                }
            }

            // city: get first language that is set NL/FR/EN
            let city = '';
            for ( let field_name of [ 'city_nl', 'city_fr', 'city_en' ] ){
                let de = $('input[name="'+field_name+'"]');
                if ( de.val() ){
                    city = de.val();
                    break;
                }
            }

            // not enough input? ⇒ bail out
            if ( ! street && ! city && ! postal_code ){
                alert( 'Geocoding failed! (not enough input)' );
                return;
            }

            // compose address
            let address = '';
            if ( street      ){ address += ' ' + street     ; }
            if ( nr          ){ address += ' ' + nr         ; }
            if ( postal_code ){ address += ' ' + postal_code; }
            if ( city        ){ address += ' ' + city       ; }

            // clean
            address = address.trim();

            // do GET request
            let response = await
            admin_crud.GET( '/en/admin/geocode/'+ encodeURIComponent( address ) );

            // something went wrong? ⇒ do nothing
            if ( response.status !== 200 ){
                alert( 'Geocoding failed!' );
                return;
            }

            let latitude  = response.data.latitude ;
            let longitude = response.data.longitude;

            if ( ! latitude || ! longitude ){
                alert( 'Geocoding failed!' );
                return;
            }

            latitude  *= 1000000;
            longitude *= 1000000;

            latitude  = Math.round( latitude  );
            longitude = Math.round( longitude );

            $('input[name="lat_times_a_million"]').val( latitude  );
            $('input[name="lng_times_a_million"]').val( longitude );

            admin_general.flash_background( $('input[name="lat_times_a_million"]') );
            admin_general.flash_background( $('input[name="lng_times_a_million"]') );
        };
    },

    on__link_goto_map__click()
    {
        return ( e ) => {
            e.preventDefault();

            let latitude  = $('input[name="lat_times_a_million"]').val();
            let longitude = $('input[name="lng_times_a_million"]').val();

            latitude  /= 1000000;
            longitude /= 1000000;

            let url = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;

            window.open( url, '_blank' );
        };

    },

    validate_input( restaurant_data )
    {
        $('.is-error').removeClass( 'is-error' );

        let validated = true;

        // mandatory fields
        for ( let key of [ 'name', 'email', 'lat_times_a_million', 'lng_times_a_million', ] ){
            if ( ! restaurant_data[key] ){
                validated = false;
                $(`[name="${key}"]`).addClass( 'is-error' );
            }
        }

        return validated;
    },

    async delete_service_restaurant_records_of_restaurant( restaurant_id )
    {
        // load records to delete
        let records = await ( async () => {
            let response = await
            admin_crud.GET( admin_crud.posturl( '260_service_restaurant', 'select_where' ), {
                'where' : {
                    'restaurant_id' : restaurant_id,
                }
            } );
            return response.data;
        })();

        for ( let r of records ){
            let response = await
            admin_crud.POST( admin_crud.posturl( '260_service_restaurant', 'delete' ), {
                ids : {
                    service_id    : r.service_id   ,
                    restaurant_id : r.restaurant_id,
                },
            } );
        }
    },

    async insert_services( restaurant_id, service_ids )
    {
        for ( let service_id of service_ids ){

            let response = await
            admin_crud.POST( admin_crud.posturl( '260_service_restaurant', 'insert' ), {
                data : {
                    restaurant_id : restaurant_id ,
                    service_id    : service_id    ,
                },
            } );
        }
    },

    on__name__blur()
    {
        return ( e ) => {
            let de_name  = $(e.currentTarget);
            let name     = de_name.attr( 'name' );
            this.set_slug( false /* don't overwrite */ );
        };
    },

    on__slug_arrow__click()
    {
        return ( e ) => {
            e.preventDefault();

            let de_clicked = $(e.currentTarget);

            this.set_slug( true /* overwrite */  );
        };
    },

    set_slug( overwrite )
    {
        // source and target dom elements
        let de_source_name    = $('input[name="name"]');
        let de_target_slug    = $('input[name="slug"]');

        // get name + variant values
        let source_name = de_source_name.val();
        let target_slug = de_target_slug.val();

        // source name empty? ⇒ do nothing
        if ( ! source_name ){
            return;
        }

        // target slug already set and should not overwrite? ⇒ do nothing
        if ( target_slug && ! overwrite ){
            return;
        }

        // slugify the product name
        target_slug = admin_general.slugify( source_name );

        de_target_slug.val( target_slug );

        admin_general.flash_background( de_target_slug );
    },

}

